NewProductController.$inject = ['$scope', 'ProductService', 'AppService', '$uibModal', '$transitions', '$timeout']

export default function NewProductController($scope, ProductService, AppService, $uibModal, $transitions, $timeout) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var shell = $scope.$parent.shell
  vm.product = ProductService.initProduct()

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.product.isPromoted = !vm.product.isPromoted
  }
  vm.setPublished = function() {
    vm.product.isPublished = !vm.product.isPublished
  }
  vm.addProductVariation = function() {
    vm.product.isFamily = true
    if (!vm.product.productVariations) vm.product.productVariations = new Array()
    vm.product.productVariations.push(ProductService.initProductVariation(vm.product))
  }
  $transitions.onBefore({}, () => {
    if (!vm.cancelled && !$scope.pristine.isPristine()) {
      ProductService.postProduct(vm.product).then(() => {
        if (sessionStorage.getItem('taskId') && sessionStorage.getItem('contactId')) {
          AppService.postTaskResponse(sessionStorage.getItem('taskId'), sessionStorage.getItem('contactId')).then(() => {
            shell.addedRGA = true
            sessionStorage.removeItem('taskId')
            sessionStorage.removeItem('contactId')
            $timeout(function() {
              shell.hideAlert('addedRGA')
            }, 5000)
          })
        }
      })
    } else {
      sessionStorage.removeItem('taskId')
      sessionStorage.removeItem('contactId')
    }
  }, {invokeLimit: 1})
}